import React, { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import { FareFfpBonusInfo } from '../../../../model/types';
import { CdnIcon } from '@shared/ui';
import { WithTooltip } from '@shared/ui';
import CircularProgress from '@mui/material/CircularProgress';

interface Props extends FareFfpBonusInfo {
	className?: string;
}

const FfpBonusInfoBlock: FC<Props> = ({ className, bonusMiles, loading, error }) => {
	const { FfpBonusInfoBlock: css } = useTheme('Entities').FareGroupV2;
	const { t } = useTranslation('FareGroup');

	const renderIcon = () => {
		if (loading) {
			return <CircularProgress size={20} classes={{ colorPrimary: css.loader }} />;
		}

		return <CdnIcon className={css.icon} icon="Services/Miles" />;
	};

	const renderValue = () => {
		let value: string | number = bonusMiles;

		if (loading || error) {
			value = '—';
		}

		const tooltipTitle = error ? error : !loading ? t('FfpBonusInfo_Tooltip') : '';

		return (
			<WithTooltip title={tooltipTitle} enterTouchDelay={0}>
				<span className={css.value}>{value}</span>
			</WithTooltip>
		);
	};

	return (
		<div className={cn(css.root, className, { [css.loading]: loading })}>
			<div className={css.leftBlock}>
				{renderIcon()}

				<span className={css.title}>{t('Miles to be credited')}</span>
			</div>

			{renderValue()}
		</div>
	);
};

export default FfpBonusInfoBlock;
